const scrubPaymentKeysFromValues = (values) => {
    const newValuesObject = { ...values };
    const listOfKeysToDelete = [
        // Payment Information Fields
        "Payment_Type",
        "Account_Number",
        "Routing_Number",
        "PayPal_Token",
        "PayPal_Payer_ID",
        "PayPal_Agreement_ID",
        "PayPal_Is_Venmo",
        "Card_Number",
        "Card_Exp_Date",
        "Card_CVV",
        "Apple_Pay_Token",
        "Express_Checkout",

        // Billing Address Fields
        "Billing_Address",
        "Billing_Address_2",
        "Billing_City",
        "Billing_State",
        "Billing_Zip",
        "Billing_Country",
        "Billing_Phone",

        // Stored Payment Fields
        "Stored_Payment",
        "Stored_Payment_ID",
        "Save_Payment",
        "Payment_Nickname",
        "Password",
        "Password_Confirm",
    ];

    const keysOnValuesObject = Object.keys(values);

    listOfKeysToDelete.forEach((key) => {
        if (keysOnValuesObject.includes(key)) {
            delete newValuesObject[key];
        }
    });

    return newValuesObject;
};

export default scrubPaymentKeysFromValues;
